/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeader
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeader {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeader
     */
    value?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeaderFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeader {
    return JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeaderFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeader {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeaderToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldHeader | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

